import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    clientInfo: null,
  },
  mutations: {
    setClientInfo (state, info) {
      state.clientInfo = info
    }
  },
  actions: {
  },
  modules: {}
})
